import { col, type Shape } from './base.ts';

export const FLUID_COMPOSITION: Shape = [
  col('c1', 'unitless', 'Methane (C1) mol fraction.'),
  col('c2', 'unitless', 'Ethane (C2) mol fraction.'),
  col('c3', 'unitless', 'Propane (C3) mol fraction.'),
  col('c6', 'unitless', 'Hexane (C6) mol fraction.'),
  col('iC4', 'unitless', 'Iso-butane (iC4) mol fraction.'),
  col('iC5', 'unitless', 'Iso-pentane (iC5) mol fraction.'),
  col('nC4', 'unitless', 'Normal-butane (nC4) mol fraction.'),
  col('nC5', 'unitless', 'Normal-pentane (nC5) mol fraction.'),
  col('n2', 'fraction', 'Nitrogen (N2) mol fraction.'),
  col('co2', 'fraction', 'Carbon-dioxide (CO2) mol fraction.'),
  col('h2s', 'fraction', 'Hydrogen-sulfide (H2S) mol fraction.'),
  col('cgr', 'liquidGasRatio', 'Condensate-gas ratio.'),
  col('wgr', 'liquidGasRatio', 'Water-gas ratio.'),
  col('condensateGravity', 'unitless', 'Condensate gravity.'),
  col('fluidType', 'unitless', 'Fluid type classification.'),
  col('specificGasGravity', 'unitless', 'Specific gas gravity.'),
  col('waterSalinity', 'unitless', 'Water salinity.'),
];

/**
 * Rate-estimation diagnostics on `RateDiagnostics_String_Agent`: performance
 * score, rate-change delta, GRD analysis status, and implied choke
 * size/coefficient. Bare source columns — `suffix === canonical`, `prefix:''`
 * (single-concern passthrough, heterogeneous names).
 */
export const RATE_DIAGNOSTICS: Shape = [
  col('wellPerformance', 'unitless', 'Well performance score (actual vs potential).'),
  col('qliqDelta', 'liquidRate', 'Liquid-rate change (delta) metric.'),
  col('grdAnalysisStatus', 'unitless', 'Gradient (GRD) analysis status.'),
  col('chokeSizeCalc', 'chokeSize', 'Calculated/implied choke size.'),
  col('chokeCdCalc', 'unitless', 'Calculated choke discharge coefficient (Cd).'),
];

/**
 * PVT fluid-sample properties on `PVTAnalysis_String_Agent` (B2): salinity,
 * sample date/type, water cut. Bare source columns — `suffix === canonical`,
 * `prefix:''` (single-concern passthrough). Distinct from the PTS
 * `PTS_FLUID_*` shapes (laboratory PVT sample metadata, not calculated PTS
 * conditions).
 */
export const PVT_SAMPLE: Shape = [
  col('salinity', 'unitless', 'Sampled water salinity.'),
  col('sampleDate', 'unitless', 'Date the fluid sample was collected.'),
  col('sampleType', 'unitless', 'Fluid-sample type / analysis classification.'),
  col('waterCut', 'fraction', 'Sampled water cut.'),
];

/**
 * Long-term inactivity status on `InactiveString_Agent` (B2): string status,
 * inactive category, and downtime start. Bare source columns —
 * `suffix === canonical`, `prefix:''`. Distinct from WellStatus's real-time
 * `onlineStatus` cluster (this classifies extended/indefinite offline strings).
 */
